// https://expertacademy.arlo.co/api/2012-02-01/pub/resources/eventsearch?fields=EventID,Name,StartDateTime,ViewUri,Media,EventTemplateID

export default async function getEvents(activeFilter = null, activeLocationFilter = null) {
    try {
        let queryUrl = '';
        if (activeFilter && activeFilter?.TemplateID && activeLocationFilter && activeLocationFilter?.Name && activeLocationFilter.Name !== "All") {
            queryUrl = `/api/arlo/fetch?data_type=eventsearch?fields=EventID,Name,StartDateTime,EndDateTime,ViewUri,Media,EventTemplateID,Presenters,Location,isFull&filter=templateid=${activeFilter.TemplateID}&filter=locname=${activeLocationFilter.Name}`;
        } else if (activeFilter && activeFilter?.TemplateID) {
            queryUrl = `/api/arlo/fetch?data_type=eventsearch?fields=EventID,Name,StartDateTime,EndDateTime,ViewUri,Media,EventTemplateID,Presenters,Location,isFull&filter=templateid=${activeFilter.TemplateID}`;
        } else if (activeLocationFilter && activeLocationFilter?.Name && activeLocationFilter.Name !== "All") {
            queryUrl = `/api/arlo/fetch?data_type=eventsearch?fields=EventID,Name,StartDateTime,EndDateTime,ViewUri,Media,EventTemplateID,Presenters,Location,isFull&filter=locname=${activeLocationFilter.Name}`;
        } else {
            return { success: false, error: 'A valid event template was not supplied.' };
        }

        let response = await fetch(queryUrl, {
            method: 'GET',
        });

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return { success: false, error: `An error occurred. Status: ${response.status}` };
        } else {
            const data = await response.json();
            const locations = [
                {
                    ID: 0,
                    Name: "All"
                }
            ];
            
            const locationNames = new Set();
            
            data.Items.forEach((item, index) => {
                if (item?.Location && !locationNames.has(item.Location.Name)) {
                    locationNames.add(item.Location.Name);
                    locations.push({
                        ID: index + 1,
                        Name: item.Location.Name
                    });
                }
            });

            return { success: true, events: data, locations: locations };
        }
    } catch (error) {
        console.error('Fetch error:', error);
        return { success: false, error: error.message };
    }
}